/** @jsxImportSource ../simboluri-jsx */
import { t, useT } from "../../i18n";
import { Pas } from "../Explica";
import { DiagramaWinkler } from "../DiagrameFundatie";
import Marime, { EtichetaNatura } from "../Marime";
import { traduceRezultat } from "../texteRezultat";

// --------------------------------------------------------- fundația în model
// Fundația NU e o etapă separată de model: din Pasul 6 încoace ea face parte
// din același domeniu OpenSees ca stâlpii și grinzile. Fără secțiunea asta,
// singurul indiciu că e acolo era perioada mai lungă — greu de observat.

export function FundatiaInModel({ r }: { r: any }) {
  useT();
  const f = r.fundatie;
  if (!f) return null;

  if (!f.activ) {
    return (
      <div className="st-findings">
        <h3>{t("struct.fem.fim_titlu")}</h3>
        <div className="st-warn">
          {t("struct.fem.fim_incastrat", { motiv: traduceRezultat(f.motiv) })}
        </div>
        <Pas titlu={t("struct.fem.fim_ce_titlu")}>
          <p>{t("struct.fem.fim_ce_p1")}</p>
          <p>{t("struct.fem.fim_ce_p2")}</p>
        </Pas>
      </div>
    );
  }

  const i = f.impact ?? {};
  return (
    <div className="st-findings">
      <h3>{t("struct.fem.fim_activ_titlu")}</h3>
      <Pas titlu={t("struct.fem.fim_da_titlu")}>
        <p>
          {t("struct.fem.fim_da_p1a")}
          <strong>{t("struct.fem.fim_grinzi")}</strong>
          {t("struct.fem.fim_da_p1b")}
          <strong>{t("struct.fem.fim_covor")}</strong>
          {t("struct.fem.fim_da_p1c")}
        </p>
        <p>{t("struct.fem.fim_da_p2")}</p>
      </Pas>
      <DiagramaWinkler />
      <div className="st-cards">
        <div className="st-card st-card-main">
          <div className="st-card-label">{t("struct.fem.fim_impact")}<EtichetaNatura cheie="delta_T1" /><Marime cheie="delta_T1" valori={{ T1_incastrat: i.T1_incastrat_s, T1_elastic: i.T1_winkler_s }} /></div>
          <div className="st-card-value">
            {i.delta_T1_pct != null ? `${i.delta_T1_pct > 0 ? "+" : ""}${i.delta_T1_pct}%` : "—"}
          </div>
          <div className="st-card-sub">
            {t("struct.fem.fim_t1", {
              incastrat: i.T1_incastrat_s ?? "—",
              elastic: i.T1_winkler_s ?? "—" })}
          </div>
        </div>
        <div className={`st-card ${i.doua_modele ? "st-card-main" : ""}`}>
          <div className="st-card-label">
            {t("struct.fem.fim_decizie",
               { prag: i.prag_delta_t1_pct ?? 10 })}
            <Marime cheie="doua_modele" />
          </div>
          <div className="st-card-value">
            {i.doua_modele == null ? "—"
              : t(i.doua_modele ? "struct.fem.fim_doua" : "struct.fem.fim_unul")}
          </div>
          <div className="st-card-sub">{i.decizie}</div>
        </div>
        <div className="st-card">
          <div className="st-card-label">{t("struct.fem.fim_retea")}<Marime cheie="retea_fundare" /></div>
          <div className="st-card-value">{f.nr_grinzi_fundare}</div>
          <div className="st-card-sub">
            {t("struct.fem.fim_retea_sub", {
              b: f.B_m, h: f.H_c_m, l: f.lungime_grinzi_m, n: f.nr_resoarte })}
            {f.abatere_lant_max_m != null && (
              <>
                {t("struct.fem.fim_abatere", { m: f.abatere_lant_max_m })}
                {f.nr_transversale
                  ? t("struct.fem.fim_transversale",
                      { n: f.nr_transversale }) : ""}
              </>
            )}
          </div>
        </div>
        <div className="st-card">
          <div className="st-card-label">{t("struct.fem.fim_teren")}<EtichetaNatura cheie="ks" /><Marime cheie="ks" /><Marime cheie="pas_resoarte" /></div>
          <div className="st-card-value">
            {f.ks_dan_cm3} <span className="st-small">daN/cm³</span>
          </div>
          <div className="st-card-sub">
            {t("struct.fem.fim_teren_sub", {
              sursa: f.ks_sursa, lambda: f.lungime_elastica_m,
              pas: f.pas_resoarte_m })}
          </div>
        </div>
      </div>
      <p className="sg-muted">
        <strong>
          {t("struct.fem.fim_pas_titlu", { pas: f.pas_resoarte_m })}
        </strong>
        {t("struct.fem.fim_pas_text", { lambda: f.lungime_elastica_m })}
        {t(f.fara_intindere
          ? "struct.fem.fim_ent" : "struct.fem.fim_liniar")}
      </p>
      <p className="sg-muted">
        {t("struct.fem.reper_calibrare", { nota: traduceRezultat(i.nota) })}
      </p>
    </div>
  );
}
